import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LeadFormPage.css';

const LeadFormPage = () => {
    const [formData, setFormData] = useState({
      firstName: '', // New
      lastName: '', // New
      email: '', // New
      phoneNumber: '',
      lookingFor: 'Flat',
      city: 'Mumbai',
      otherCity: '',
      area: '',
      budget: '',
      priorities: [],
      moveDate: '',
      sharedFlat: '', // Changed from sharingOption
      peopleCount: '', // Made compulsory, so initial value is empty
      otherPreferences: '',
    });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // Access the URL from the environment variable
    const SCRIPT_URL = process.env.REACT_APP_SCRIPT_URL;

    const handleChange = (e) => {
      const { name, value, type, checked } = e.target;
      if (type === 'checkbox') {
        setFormData((prevData) => {
          const newPriorities = checked
            ? [...prevData.priorities, value]
            : prevData.priorities.filter((priority) => priority !== value);
          return { ...prevData, priorities: newPriorities };
        });
      } else {
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        // Check if the URL is loaded properly
        if (!SCRIPT_URL) {
            console.error("The script URL is not defined. Please check your .env file.");
            alert("Configuration error: Script URL not found.");
            setLoading(false);
            return;
        }

        try {
            const finalCity = formData.city === 'Other' ? formData.otherCity : formData.city;
            const prioritiesString = formData.priorities.join(', ');

            // Create a new dataToSend string with all your updated fields
            const dataToSend = `firstName=${encodeURIComponent(formData.firstName)}&lastName=${encodeURIComponent(formData.lastName)}&email=${encodeURIComponent(formData.email)}&phoneNumber=${encodeURIComponent(formData.phoneNumber)}&lookingFor=${encodeURIComponent(formData.lookingFor)}&city=${encodeURIComponent(finalCity)}&area=${encodeURIComponent(formData.area)}&budget=${encodeURIComponent(formData.budget)}&priorities=${encodeURIComponent(prioritiesString)}&moveDate=${encodeURIComponent(formData.moveDate)}&sharedFlat=${encodeURIComponent(formData.sharedFlat)}&peopleCount=${encodeURIComponent(formData.peopleCount)}&otherPreferences=${encodeURIComponent(formData.otherPreferences)}`;

            await fetch(SCRIPT_URL, {
                method: 'POST',
                body: dataToSend,
                mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });

            console.log('Form submitted successfully!');
            navigate('/thank-you');

        } catch (error) {
            console.error('Error submitting the form:', error);
            alert('There was an error submitting the form. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="lead-form-page">
            <div className="form-container">
                <h2>Looking for a place to stay? Let's help you move in stress-free!</h2>
                <p>Fill this quick form and we'll match you with verified places based on your needs.</p>
                <form onSubmit={handleSubmit}>
                    {/* 1. First Name & Last Name */}
                    <div className="name-fields">
                        <div className="form-field">
                            <label htmlFor="firstName">First Name*</label>
                            <input
                                type="text"
                                id="firstName"
                                name="firstName"
                                value={formData.firstName}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-field">
                            <label htmlFor="lastName">Last Name*</label>
                            <input
                                type="text"
                                id="lastName"
                                name="lastName"
                                value={formData.lastName}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>
                    
                    {/* 2. Email Address (Optional) */}
                    <label htmlFor="email">Email Address</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                    />

                    <label htmlFor="phoneNumber">Phone Number*</label>
                    <input
                        type="tel"
                        id="phoneNumber"
                        name="phoneNumber"
                        value={formData.phoneNumber}
                        onChange={handleChange}
                        required
                    />

                    <label htmlFor="lookingFor">Looking for*</label>
                    <select
                        id="lookingFor"
                        name="lookingFor"
                        value={formData.lookingFor}
                        onChange={handleChange}
                        required
                    >
                        <option value="Flat">Flat</option>
                        <option value="PG">PG</option>
                        <option value="Any is fine">Any is fine</option>
                    </select>

                    {/* 3. Added new cities */}
                    <label htmlFor="city">Which city are you looking in?*</label>
                    <select
                        id="city"
                        name="city"
                        value={formData.city}
                        onChange={handleChange}
                        required
                    >
                        <option value="Mumbai">Mumbai</option>
                        <option value="Delhi">Delhi</option>
                        <option value="Pune">Pune</option>
                        <option value="Bangalore">Bangalore</option>
                        <option value="Noida / Greater Noida">Noida / Greater Noida</option>
                        <option value="Gurugram">Gurugram</option>
                        <option value="Navi Mumbai">Navi Mumbai</option>
                        <option value="Hyderabad">Hyderabad</option>
                        <option value="Other">Other:</option>
                    </select>
                    {formData.city === 'Other' && (
                        <input
                            type="text"
                            name="otherCity"
                            placeholder="Please specify your city"
                            value={formData.otherCity}
                            onChange={handleChange}
                            required
                        />
                    )}

                    <label htmlFor="area">Which area?*</label>
                    <input
                        type="text"
                        id="area"
                        name="area"
                        value={formData.area}
                        onChange={handleChange}
                        required
                    />

                    {/* 4. Changed budget options */}
                    <label htmlFor="budget">Budget per person</label>
                    <select
                        id="budget"
                        name="budget"
                        value={formData.budget}
                        onChange={handleChange}
                    >
                        <option value="">Select...</option>
                        <option value="Below ₹10,000">Below ₹10,000</option>
                        <option value="₹10,000 - ₹15,000">₹10,000 - ₹15,000</option>
                        <option value="₹15,000 - ₹20,000">₹15,000 - ₹20,000</option>
                        <option value="₹20,000 - ₹25,000">₹20,000 - ₹25,000</option>
                        <option value="₹25,000 - ₹30,000">₹25,000 - ₹30,000</option>
                        <option value="Above ₹30,000">Above ₹30,000</option>
                    </select>

                    <label>What are your top priorities?</label>
                    <div className="checkbox-group">
                        <label><input type="checkbox" name="priorities" value="Cleanliness" onChange={handleChange} /> Cleanliness</label>
                        <label><input type="checkbox" name="priorities" value="Food included" onChange={handleChange} /> Food included</label>
                        <label><input type="checkbox" name="priorities" value="Near public transport" onChange={handleChange} /> Near public transport</label>
                        <label><input type="checkbox" name="priorities" value="Girls/Boys Only PG" onChange={handleChange} /> Girls/Boys Only PG</label>
                        <label><input type="checkbox" name="priorities" value="Safe neighbourhood" onChange={handleChange} /> Safe neighbourhood</label>
                        <label><input type="checkbox" name="priorities" value="No restrictions" onChange={handleChange} /> No restrictions</label>
                    </div>

                    {/* 6. Made the last three questions compulsory */}
                    <label htmlFor="moveDate">When do you want to move?*</label>
                    <input
                        type="date"
                        id="moveDate"
                        name="moveDate"
                        value={formData.moveDate}
                        onChange={handleChange}
                        required
                    />

                    {/* 5. Changed 'sharingOption' question */}
                    <label htmlFor="sharedFlat">Would you consider a shared Flat/PG?*</label>
                    <select
                        id="sharedFlat"
                        name="sharedFlat"
                        value={formData.sharedFlat}
                        onChange={handleChange}
                        required
                    >
                        <option value="">Select...</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>

                    <label htmlFor="peopleCount">How many people are with you?*</label>
                    <select
                        id="peopleCount"
                        name="peopleCount"
                        value={formData.peopleCount}
                        onChange={handleChange}
                        required
                    >
                        <option value="">Select...</option>
                        <option value="Alone">Alone</option>
                        <option value="+1">+1</option>
                        <option value="+2">+2</option>
                        <option value="+3">+3</option>
                        <option value="More">More</option>
                    </select>

                    <label htmlFor="otherPreferences">Any other preference that we should keep in mind?</label>
                    <textarea
                        id="otherPreferences"
                        name="otherPreferences"
                        value={formData.otherPreferences}
                        onChange={handleChange}
                    ></textarea>

                    <button type="submit" disabled={loading}>
                        {loading ? 'Submitting...' : 'Submit'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default LeadFormPage;